import api from "@helpers/api";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/procurements`;

export const createFinalReceive = async (reqData: any, id: string) => {
  try {
    const res = await api.post(`${apiEndPoint}/${id}/final-receive`, {
      ...reqData,
    });
    const resData = await res.data;
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
    };
  }
};

export const fetchFinalReceiveById = async (procurementId: number | string) => {
  try {
    const res = await api.get(`${apiEndPoint}/${procurementId}/final-receive`);
    const resData = await res.data;
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
    };
  }
};

export const updateFinalReceive = async (
  reqData: any,
  procurementId: number | string,
  finalReceiveId: number | string,
) => {
  try {
    const res = await api.put(
      `${apiEndPoint}/${procurementId}/final-receive/${finalReceiveId}`,
      {
        ...reqData,
      },
    );
    const resData = await res.data;
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
    };
  }
};
